import { FieldPrice } from '../types';

export const getStringOrNull = (value: any) => String(value) || null;

export const getBookingDateTimePrice = (
  dateTime: Date,
  priceIntervals: FieldPrice[],
  defaultPrice: number
) => {
  const priceIntervalExists = priceIntervals.find((interval) => {
    const { day, startTime, endTime } = interval;

    const startHour = Number(startTime.split(':')[0]);
    const endHour = Number(endTime.split(':')[0]);

    return (
      dateTime.getDay() === day &&
      dateTime.getHours() >= startHour &&
      dateTime.getHours() < endHour
    );
  });

  if (priceIntervalExists) {
    return priceIntervalExists.price;
  } else {
    return defaultPrice;
  }
};

export const getDayPrice = (
  day: number,
  startTime: string,
  endTime: string,
  priceIntervals: FieldPrice[],
  defaultPrice: number
) => {
  const priceIntervalExists = priceIntervals.find((interval) => {
    const { day: intervalDay, startTime: intervalStartTime, endTime: intervalEndTime } = interval;

    const intervalStartHours = Number(intervalStartTime.split(':')[0]);
    const intervalEndHours = Number(intervalEndTime.split(':')[0]);

    const startHours = Number(startTime.split(':')[0]);
    const endHours = Number(endTime.split(':')[0]);

    return (
      day === intervalDay &&
      startHours >= intervalStartHours &&
      endHours < intervalEndHours
    );
  });

  if (priceIntervalExists) {
    return priceIntervalExists.price;
  } else {
    return defaultPrice;
  }
};
